// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProposalSection_section-open__BHygY {
  padding: 52px 24px;
  background: transparent;
  border: 0;
  box-shadow: none;
  overflow: visible;
  max-width: 1280px;
  margin: 0 auto;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
@media (min-width: 1080px) {
  .ProposalSection_section-open__BHygY {
    padding: 52px 40px;
  }
}

.ProposalSection_section-head__svoiX {
  display: grid;
  row-gap: 16px;
  column-gap: 0;
  margin-bottom: 36px;
}

.ProposalSection_section-head--split__oMlik {
  grid-template-columns: minmax(400px, 1fr) minmax(407px, 1.1fr);
  row-gap: 16px;
  column-gap: clamp(36px, 6vw, 78px);
  align-items: end;
}
@media (max-width: 1024px) {
  .ProposalSection_section-head--split__oMlik {
    grid-template-columns: 1fr;
    row-gap: 0;
  }
  .ProposalSection_section-head--split__oMlik .ProposalSection_section-title__IYTA6,
  .ProposalSection_section-head--split__oMlik .ProposalSection_section-copy__XUk9i {
    margin-bottom: 0;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ProposalSection_section-head--split__oMlik {
    grid-template-columns: 1fr;
  }
  .ProposalSection_section-head--split__oMlik .ProposalSection_section-title__IYTA6,
  .ProposalSection_section-head--split__oMlik .ProposalSection_section-copy__XUk9i {
    justify-self: center;
    text-align: center;
  }
}

.ProposalSection_section-head--proposal__MfANt {
  align-items: start;
}
.ProposalSection_section-head--proposal__MfANt .ProposalSection_section-copy__XUk9i {
  align-self: start;
  margin-top: 0;
  margin-bottom: 0;
}

.ProposalSection_section-head--split__oMlik .ProposalSection_eyebrow__KktAK {
  grid-column: 1/-1;
}

.ProposalSection_section-head--split__oMlik .ProposalSection_section-title__IYTA6 {
  margin-bottom: 0;
}

.ProposalSection_section-head--split__oMlik .ProposalSection_section-copy__XUk9i {
  justify-self: end;
  max-width: 680px;
  margin-bottom: 2px;
}
@media (max-width: 1024px) {
  .ProposalSection_section-head--split__oMlik .ProposalSection_section-copy__XUk9i {
    margin-top: 30px;
    justify-self: center;
    text-align: center;
    max-width: none;
  }
}

.ProposalSection_eyebrow__KktAK {
  margin: 0;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #82B194;
  text-align: left;
}
@media (max-width: 1024px) {
  .ProposalSection_eyebrow__KktAK {
    text-align: center;
  }
}

.ProposalSection_section-title__IYTA6 {
  margin: 0 0 20px;
  max-width: 500px;
  font-size: 42px;
  line-height: 1.08;
  letter-spacing: -0.035em;
  font-weight: 700;
  color: #13231D;
  text-align: left;
}
@media (max-width: 820px) {
  .ProposalSection_section-title__IYTA6 {
    max-width: none;
    font-size: 32px;
    margin-bottom: 12px;
    text-align: center;
  }
}

.ProposalSection_section-copy__XUk9i {
  margin: 0;
  max-width: 780px;
  font-size: 17px;
  line-height: 1.72;
  color: #5F726B;
}
@media (max-width: 820px) {
  .ProposalSection_section-copy__XUk9i {
    font-size: 16px;
  }
}

.ProposalSection_grid-3__cIqc0 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media (max-width: 1080px) {
  .ProposalSection_grid-3__cIqc0 {
    grid-template-columns: 1fr;
  }
}

.ProposalSection_value-cards__52wJs {
  gap: 20px;
  align-items: stretch;
  max-width: none;
  align-content: stretch;
}
@media (max-width: 1080px) {
  .ProposalSection_value-cards__52wJs {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}
@media (max-width: 820px) {
  .ProposalSection_value-cards__52wJs {
    grid-template-columns: 1fr;
  }
}

.ProposalSection_value-item__YmZNa {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #5F726B;
  background: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 24px;
  padding: 26px 24px;
  box-shadow: 0 16px 42px rgba(18, 34, 29, 0.045);
}
.ProposalSection_value-item__YmZNa h3 {
  margin: 0 0 2px 0;
  font-size: 22px;
  line-height: 1.12;
  letter-spacing: -0.03em;
  color: #13231D;
}
.ProposalSection_value-item__title--visibilidad__EpMRE {
  height: 39.73px;
}
.ProposalSection_value-item__YmZNa p {
  margin: 0;
  max-width: 60ch;
  font-size: 15.5px;
  line-height: 1.62;
  color: #5F726B;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/ProposalSection/ProposalSection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,oFDJU;ACqBZ;AAfE;EAVF;IAWI,kBAAA;EAkBF;AACF;;AAfA;EACE,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAkBF;;AAfA;EACE,8DAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;AAkBF;AAhBE;EANF;IAOI,0BAAA;IACA,UAAA;EAmBF;EAjBE;;IAEE,gBAAA;EAmBJ;AACF;AAhBE;EAhBF;IAiBI,0BAAA;EAmBF;EAjBE;;IAEE,oBAAA;IACA,kBAAA;EAmBJ;AACF;;AAfA;EACE,kBAAA;AAkBF;AAhBE;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;AAkBJ;;AAdA;EACE,iBAAA;AAiBF;;AAdA;EACE,gBAAA;AAiBF;;AAdA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAiBF;AAfE;EALF;IAMI,gBAAA;IACA,oBAAA;IACA,kBAAA;IACA,eAAA;EAkBF;AACF;;AAfA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAkBF;AAhBE;EAVF;IAWI,kBAAA;EAmBF;AACF;;AAhBA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAmBF;AAjBE;EAVF;IAWI,eAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EAoBF;AACF;;AAjBA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAoBF;AAlBE;EAPF;IAQI,eAAA;EAqBF;AACF;;AAlBA;EACE,aAAA;EACA,SAAA;EACA,gDAAA;AAqBF;AAnBE;EALF;IAMI,0BAAA;EAsBF;AACF;;AAnBA;EACE,SAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;AAsBF;AApBE;EANF;IAOI,8BAAA;IACA,SAAA;EAuBF;AACF;AArBE;EAXF;IAYI,0BAAA;EAwBF;AACF;;AArBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;AAwBF;AAtBE;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAwBJ;AArBE;EACE,eAAA;AAuBJ;AApBE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAsBJ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.section-open {\n  padding: 52px 24px;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  overflow: visible;\n  max-width: 1280px;\n  margin: 0 auto;\n  font-family: $font-main;\n\n  @media (min-width: 1080px) {\n    padding: 52px 40px;\n  }\n}\n\n.section-head {\n  display: grid;\n  row-gap: 16px;\n  column-gap: 0;\n  margin-bottom: 36px;\n}\n\n.section-head--split {\n  grid-template-columns: minmax(400px, 1fr) minmax(407px, 1.1fr);\n  row-gap: 16px;\n  column-gap: clamp(36px, 6vw, 78px);\n  align-items: end;\n\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr;\n    row-gap: 0;\n\n    .section-title,\n    .section-copy {\n      margin-bottom: 0;\n    }\n  }\n\n  @media (min-width: 768px) and (max-width: 1024px) {\n    grid-template-columns: 1fr;\n\n    .section-title,\n    .section-copy {\n      justify-self: center;\n      text-align: center;\n    }\n  }\n}\n\n.section-head--proposal {\n  align-items: start;\n\n  .section-copy {\n    align-self: start;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n.section-head--split .eyebrow {\n  grid-column: 1 / -1;\n}\n\n.section-head--split .section-title {\n  margin-bottom: 0;\n}\n\n.section-head--split .section-copy {\n  justify-self: end;\n  max-width: 680px;\n  margin-bottom: 2px;\n\n  @media (max-width: 1024px) {\n    margin-top: 30px;\n    justify-self: center;\n    text-align: center;\n    max-width: none;\n  }\n}\n\n.eyebrow {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #82B194;\n  text-align: left;\n\n  @media (max-width: 1024px) {\n    text-align: center;\n  }\n}\n\n.section-title {\n  margin: 0 0 20px;\n  max-width: 500px;\n  font-size: 42px;\n  line-height: 1.08;\n  letter-spacing: -0.035em;\n  font-weight: 700;\n  color: #13231D;\n  text-align: left;\n\n  @media (max-width: 820px) {\n    max-width: none;\n    font-size: 32px;\n    margin-bottom: 12px;\n    text-align: center;\n  }\n}\n\n.section-copy {\n  margin: 0;\n  max-width: 780px;\n  font-size: 17px;\n  line-height: 1.72;\n  color: #5F726B;\n\n  @media (max-width: 820px) {\n    font-size: 16px;\n  }\n}\n\n.grid-3 {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n\n  @media (max-width: 1080px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.value-cards {\n  gap: 20px;\n  align-items: stretch;\n  max-width: none;\n  align-content: stretch;\n\n  @media (max-width: 1080px) {\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n\n  @media (max-width: 820px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.value-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  color: #5F726B;\n  background: #F7F5F1;\n  border: 1px solid rgba(19, 35, 29, 0.08);\n  border-radius: 24px;\n  padding: 26px 24px;\n  box-shadow: 0 16px 42px rgba(18, 34, 29, 0.045);\n\n  h3 {\n    margin: 0 0 2px 0;\n    font-size: 22px;\n    line-height: 1.12;\n    letter-spacing: -0.03em;\n    color: #13231D;\n  }\n\n  &__title--visibilidad {\n    height: 39.73px;\n  }\n\n  p {\n    margin: 0;\n    max-width: 60ch;\n    font-size: 15.5px;\n    line-height: 1.62;\n    color: #5F726B;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section-open": `ProposalSection_section-open__BHygY`,
	"section-head": `ProposalSection_section-head__svoiX`,
	"section-head--split": `ProposalSection_section-head--split__oMlik`,
	"section-title": `ProposalSection_section-title__IYTA6`,
	"section-copy": `ProposalSection_section-copy__XUk9i`,
	"section-head--proposal": `ProposalSection_section-head--proposal__MfANt`,
	"eyebrow": `ProposalSection_eyebrow__KktAK`,
	"grid-3": `ProposalSection_grid-3__cIqc0`,
	"value-cards": `ProposalSection_value-cards__52wJs`,
	"value-item": `ProposalSection_value-item__YmZNa`,
	"value-item__title--visibilidad": `ProposalSection_value-item__title--visibilidad__EpMRE`
};
export default ___CSS_LOADER_EXPORT___;
